<template>
  <header id="header">
    <el-row
      class="header-content container-d inherit-h"
      justify="space-between"
    >
      <el-col
        class="header-left bg-gradient inherit-h"
        :xs="19"
        :sm="9"
        :md="7"
        :lg="6"
        :xl="5"
      >
        <div class="header-left-content inherit-h flex-one">
          <div class="logo flex-one inherit-h">
            <img :src="LOGO_IMG" alt="" srcset="" style="width: 85%" />
          </div>
          <div
            class="title fs-xl flex-one"
            v-html="titleHtml"
            :xs="18"
            :sm="19"
            :md="19"
            :lg="19"
          />
          <div class="triangle bg-gradient" />
        </div>
      </el-col>
      <!-- <el-col class="header-right flex-one jc-end" :xs="14" :sm="10" :md="8">
        <SearchBar />
      </el-col> -->
    </el-row>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue'

import SearchBar from '@/components/search-bar/index.vue'
import useSize from '@/hooks/useSize.js'

import LOGO_IMG from '@/assets/images/logo.png'
import { ORG_INFORMATION } from '@/config/constant'

const { name: TITLE } = ORG_INFORMATION

const { w } = useSize()

const titleHtml = `<span>
    <span class="fs-sm" style="padding-bottom: 2px;opacity: 0.8">中国医学科学院   北京协和医学院</span><br /><span class="shadow-text">医学信息研究所 图书馆</span>
    </span>`

const size = computed(() => {
  // if (w.value > 1200) return '80%'
  // if (w.value > 992) return '70%'
  if (w.value > 768) return '78%'
  else return '60%'
})
</script>

<style lang="scss" scoped>
#header {
  $header-h: 75px;
  $padding: 1.8%;
  position: relative;
  background: #fff;
  height: $header-h;
  .header {
    &-left {
      padding-left: $padding;
      color: #fff;
      &-content {
        position: relative;
      }
      .logo {
        width: 75px;
        position: relative;
      }
      .title {
        flex: 1;
        letter-spacing: 0.125rem;
        height: inherit;
      }
      .triangle {
        position: absolute;
        right: 0;
        top: 0;
        width: 0;
        height: 0;
        line-height: 0;
        font-size: 0;
        border-style: solid;
        border-color: transparent;
        border-width: 0 30px 75px 0px;
        border-right-color: #fff;
        border-top-color: #fff;
      }
    }
    &-right {
      padding-right: $padding;
      height: inherit;
    }
  }
}

@media screen and (max-width: 500px) {
  #header {
    height: 65px;

    .header {
      &-left {
        .logo {
          width: 65px;
        }
        .triangle {
          border-width: 0 30px 65px 0px;
        }
      }
    }
  }
}
</style>
